<template>
  <div class="stepFour">
    <h1 class="stepFour__title">
      {{ $t('partners.multisport.steps.step4.title') }}
    </h1>

    <p class="stepFour__message">
      {{ $t('partners.multisport.steps.step4.message') }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.stepFour {
  padding: 4rem 2rem;
  text-align: center;

  &__title {
    @include h11;
    color: $text-500;
    text-align: center;
  }

  &__message {
    @include body-4;
    color: $text-500;
    text-align: center;
  }
}
</style>
